<div class="min-h-screen relative overflow-hidden bg-gray-100 flex items-center justify-center" [class.md:block]="mode === 'login' || mode === 'forgot'">

  <!-- ═══════════════════════════════════════════════════════════
       FACE PENDING — Awaiting admin approval
       ═══════════════════════════════════════════════════════════ -->
  <ng-container *ngIf="mode === 'face_pending'">
    <div class="min-h-screen w-full bg-[#F0F0F5] flex flex-col">

      <!-- Header -->
      <header class="h-16 flex-shrink-0 bg-white px-6 lg:px-10 flex items-center justify-between border-b border-gray-200">
        <img src="https://www.hubblehox.com/wp-content/uploads/2025/01/hubblehox-favicon.png?v=2" class="h-8 w-auto" alt="HubbleHox" />
        <div class="flex items-center gap-2 cursor-pointer">
          <div class="w-9 h-9 rounded-full bg-[#E5E7EB] flex items-center justify-center overflow-hidden">
            <svg class="w-5 h-5 text-[#6B7280]" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z" />
            </svg>
          </div>
          <span class="text-[14px] font-medium text-[#111827]">{{ face_pending_data?.name || 'User' }}</span>
          <svg class="w-4 h-4 text-[#6B7280]" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      </header>

      <!-- Main content -->
      <main class="flex-1 flex items-center justify-center pt-20 py-10 px-4 overflow-y-auto">

        <!-- Card: Frame 2087327123 -->
        <div class="flex flex-col items-center w-full max-w-[745px] px-10 py-6 gap-6 bg-white rounded-[27px]" style="box-shadow: 0px 1px 2px rgba(0,0,0,0.3), 0px 2px 6px 2px rgba(0,0,0,0.15);">

          <!-- Icon circle: Frame 2087327164 — orange clock -->
          <div class="w-24 h-24 rounded-full flex items-center justify-center flex-shrink-0" style="background: rgba(209, 126, 63, 0.12);">
            <svg width="41" height="41" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="9" stroke="#D17E3F" stroke-width="1.5" />
              <path stroke="#D17E3F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" d="M12 7v5l3 3" />
            </svg>
          </div>

          <!-- Title -->
          <h2 class="text-[32px] font-medium text-[#D17E3F] tracking-[0.02em] capitalize leading-[35px]">
            Approval Requested
          </h2>

          <!-- Subtitle -->
          <p class="text-[16px] font-normal text-[#212121] text-center tracking-[0.02em] capitalize leading-[18px] w-full">
            Your request has been sent to the admin for manual verification. We'll notify you here as soon as it's reviewed.
          </p>

          <!-- Info table: Frame 2087327169 -->
          <div class="w-full flex flex-col gap-6 px-6 py-4 rounded-[16px] border border-[#E1E8F5] bg-[#EBF2FF]">

            <!-- Submitted photo row: Frame 2087327165 -->
            <div class="flex justify-between items-center gap-4">
              <span class="text-[16px] font-normal text-[#212121] tracking-[0.02em] capitalize leading-[18px]">Submitted photo</span>
              <div class="w-[100px] h-[70px] rounded-[2px] overflow-hidden bg-white flex-shrink-0">
                <img *ngIf="face_pending_data?.captured_image || face_image_base64" [src]="face_pending_data?.captured_image || face_image_base64" class="w-full h-full object-cover" alt="Submitted photo" />
                <div *ngIf="!face_pending_data?.captured_image && !face_image_base64" class="w-full h-full flex items-center justify-center bg-[#F3F4F6]">
                  <svg class="w-6 h-6 text-[#9CA3AF]" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                    <path stroke-linecap="round" stroke-linejoin="round" d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </div>
              </div>
            </div>

            <!-- Divider -->
            <div class="h-px w-full bg-[#D9D9D9]"></div>

            <!-- Request ID row -->
            <div class="flex justify-between items-center gap-4">
              <span class="text-[16px] font-normal text-[#212121] tracking-[0.02em] capitalize leading-[18px]">Request ID</span>
              <span class="text-[14px] font-medium text-[#212121] leading-[15px] tracking-[0.02em] capitalize">
                {{ face_pending_data?.request_id || '—' }}
              </span>
            </div>

            <!-- Divider -->
            <div class="h-px w-full bg-[#D9D9D9]"></div>

            <!-- Submitted on row -->
            <div class="flex justify-between items-center gap-4">
              <span class="text-[16px] font-normal text-[#212121] tracking-[0.02em] capitalize leading-[18px]">Submitted on</span>
              <span class="text-[14px] font-medium text-[#212121] leading-[15px] tracking-[0.02em] capitalize">
                {{ face_pending_submitted_at }}
              </span>
            </div>

            <!-- Divider -->
            <div class="h-px w-full bg-[#D9D9D9]"></div>

            <!-- Status row -->
            <div class="flex justify-between items-center gap-4">
              <span class="text-[16px] font-normal text-[#212121] tracking-[0.02em] capitalize leading-[18px]">Status</span>
              <div class="flex items-center gap-2">
                <span class="w-3 h-3 rounded-full bg-[#D17E3F] flex-shrink-0"></span>
                <span class="text-[14px] font-medium text-[#D17E3F] leading-[15px] tracking-[0.02em] capitalize">Review Pending</span>
              </div>
            </div>
          </div>

          <!-- Helper text -->
          <p class="text-[14px] font-normal text-[#666666] text-center leading-[15px] tracking-[0.02em] capitalize w-full">
            This usually takes a few minutes. You can safely leave this page.
          </p>

          <!-- Back to Login button (outline) -->
          <button type="button" (click)="backToLogin()" class="flex items-center justify-center w-[201px] h-[40px] rounded-full border border-[#3F41D1] bg-transparent hover:bg-[#3F41D1]/5 transition-colors">
            <span class="text-[14px] font-medium text-[#3F41D1] capitalize leading-[15px]">Back to Login</span>
          </button>

        </div>
      </main>
    </div>
  </ng-container>

  <!-- ═══════════════════════════════════════════════════════════
       FACE REJECTED — Admin rejected the request
       ═══════════════════════════════════════════════════════════ -->
  <ng-container *ngIf="mode === 'face_rejected'">
    <div class="min-h-screen w-full bg-[#F0F0F5] flex flex-col">

      <!-- Header -->
      <header class="h-16 flex-shrink-0 bg-white px-6 lg:px-10 flex items-center justify-between border-b border-gray-200">
        <img src="https://www.hubblehox.com/wp-content/uploads/2025/01/hubblehox-favicon.png?v=2" class="h-8 w-auto" alt="HubbleHox" />
        <div class="flex items-center gap-2 cursor-pointer">
          <div class="w-9 h-9 rounded-full bg-[#E5E7EB] flex items-center justify-center overflow-hidden">
            <svg class="w-5 h-5 text-[#6B7280]" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z" />
            </svg>
          </div>
          <span class="text-[14px] font-medium text-[#111827]">{{ face_rejected_data?.name || 'User' }}</span>
          <svg class="w-4 h-4 text-[#6B7280]" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      </header>

      <!-- Main content -->
      <main class="flex-1 flex items-center justify-center pt-20 py-10 px-4 overflow-y-auto">

        <!-- Card: matches Figma Frame 2087327123 -->
        <div class="flex flex-col items-center w-full max-w-[745px] px-10 py-6 gap-6 bg-white rounded-[27px]" style="box-shadow: 0px 1px 2px rgba(0,0,0,0.3), 0px 2px 6px 2px rgba(0,0,0,0.15);">

          <!-- Icon circle: Frame 2087327164 -->
          <div class="w-24 h-24 rounded-full bg-[#FFE2E2] flex items-center justify-center flex-shrink-0">
            <svg width="41" height="41" viewBox="0 0 24 24" fill="none">
              <path stroke="#E5383B" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>

          <!-- Title -->
          <h2 class="text-[32px] font-medium text-[#E6393E] tracking-[0.02em] capitalize leading-[35px]">
            Verification Rejected
          </h2>

          <!-- Subtitle -->
          <p class="text-[16px] font-normal text-[#212121] text-center tracking-[0.02em] capitalize leading-[18px] w-full">
            The admin couldn't verify your identity from the photo you submitted. Please review the comments below and try again.
          </p>

          <!-- Admin comments box: Frame 2087327162 -->
          <div class="w-full flex flex-col gap-2 px-6 py-3 rounded-[8px] border border-[#E6393E]" style="background: rgba(255, 226, 226, 0.2);">

            <!-- Label row: Frame 2087327171 -->
            <div class="flex items-center gap-2">
              <svg class="w-[18px] h-[18px] flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="#9F0712" stroke-width="1.5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-3 3v-3z" />
              </svg>
              <span class="text-[14px] font-medium text-[#9F0712] leading-[21px]">Admin comments</span>
            </div>

            <!-- Comment text -->
            <p class="text-[14px] font-normal text-[#666666] leading-[21px]">
              {{ face_rejected_data?.comment || 'No additional comments provided by the admin.' }}
            </p>
          </div>

          <!-- Info table: Frame 2087327169 -->
          <div class="w-full flex flex-col gap-6 px-6 py-4 rounded-[16px] border border-[#E1E8F5] bg-[#EBF2FF]">

            <!-- Request ID row -->
            <div class="flex justify-between items-center gap-4">
              <span class="text-[16px] font-normal text-[#212121] tracking-[0.02em] capitalize leading-[18px]">Request ID</span>
              <span class="text-[14px] font-medium text-[#212121] leading-[15px] tracking-[0.02em] capitalize">
                {{ face_rejected_data?.request_id || '—' }}
              </span>
            </div>

            <!-- Divider -->
            <div class="h-px w-full bg-[#D9D9D9]"></div>

            <!-- Reviewed by row -->
            <div class="flex justify-between items-center gap-4">
              <span class="text-[16px] font-normal text-[#212121] tracking-[0.02em] capitalize leading-[18px]">Reviewed by</span>
              <span class="text-[14px] font-medium text-[#212121] leading-[15px] tracking-[0.02em] capitalize">
                {{face_rejected_data?.reviewer_name || 'Admin'}} · {{ face_rejected_data?.reviewer_role || 'Admin' }}
              </span>
            </div>

            <!-- Divider -->
            <div class="h-px w-full bg-[#D9D9D9]"></div>

            <!-- Status row -->
            <div class="flex justify-between items-center gap-4">
              <span class="text-[16px] font-normal text-[#212121] tracking-[0.02em] capitalize leading-[18px]">Status</span>
              <div class="flex items-center gap-2">
                <span class="w-3 h-3 rounded-full bg-[#E6393E] flex-shrink-0"></span>
                <span class="text-[14px] font-medium text-[#E6393E] leading-[15px] tracking-[0.02em] capitalize">Rejected</span>
              </div>
            </div>
          </div>

          <!-- Re-Capture button: Button -->
          <button type="button" (click)="recaptureAndResubmit()" class="flex items-center justify-center gap-2 w-[309px] h-[40px] bg-[#3F41D1] rounded-full pl-4 pr-6 hover:bg-[#3335b5] transition-colors">
            <svg class="w-[18px] h-[18px] flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="white" stroke-width="1.5">
              <path stroke-linecap="round" stroke-linejoin="round" d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
              <path stroke-linecap="round" stroke-linejoin="round" d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
            <span class="text-[14px] font-medium text-white capitalize leading-[15px]">Re-Capture &amp; Re-Submit</span>
          </button>

          <!-- Need Help -->
          <p class="text-[14px] font-normal text-[#666666] text-center leading-[15px] tracking-[0.02em] capitalize w-full">
            Need Help?
            <a href="mailto:support@hubblehox.com" class="text-[#3F41D1] underline underline-offset-2 hover:text-[#3335b5]">Contact support</a>
          </p>

        </div>
      </main>
    </div>
  </ng-container>

  <!-- Background (login / forgot modes only) -->
  <div *ngIf="mode === 'login' || mode === 'forgot'" class="absolute inset-y-0 left-0 w-[80%] hidden md:block">
    <img src="../assets/Login_page.png" class="w-full h-full object-cover" alt="Login Background" />
  </div>

  <!-- Normal Login / Forgot Card -->
  <div *ngIf="mode === 'login' || mode === 'forgot'" class="relative w-full max-w-md bg-white rounded-2xl shadow-2xl px-10 py-12 mx-4
              md:absolute md:right-[7%] md:top-1/2 md:-translate-y-1/2">

    <!-- Logo -->
    <div class="text-center mb-6">
      <img src="https://www.hubblehox.com/wp-content/uploads/2025/01/hubblehox-favicon.png?v=2" class="w-12 h-12 mx-auto mb-4" />
    </div>

    <form *ngIf="mode === 'login'" [formGroup]="loginForm" class="space-y-5">

      <p class="font-['Roboto'] font-semibold text-[36px] ">Login</p>

      <!-- STAFF -->
      <div class="flex flex-col gap-4">
        <div class="flex flex-col gap-[10px]" *ngIf=" user_type==='staff'">
          <p class=" font-normal text-[18px]">Email ID</p>
          <app-text-input [img]="'../../../assets/solar_user-broken.png'" [is_login]="true" formControlName="email" label="Email ID" placeholder="Enter Email ID"> </app-text-input>
        </div>

        <div class="flex flex-col gap-[10px]" *ngIf=" user_type==='student'">
          <p class=" font-normal text-[18px]">User ID</p>
          <app-text-input [img]="'../../../assets/solar_user-broken.png'" [is_login]="true" [is_required]="true" class="w-full" placeholder="Enter User ID" [label]="'User Id'" formControlName="roll_number"></app-text-input>
        </div>

        <div class="flex flex-col gap-[10px]">
          <p class="font-normal text-[18px]">Password</p>
          <app-text-input [img]="'../../../assets/password.png'" [is_login]="true" (keyup.enter)="submit()" type="password" [mask]="true" [is_required]="true" class="w-full" placeholder="Enter Password" [label]="'Password'" formControlName="password"></app-text-input>
        </div>
      </div>
      <div class="flex flex-col items-center gap-4 w-full">
        <button type="button" (click)="submit()" class="flex items-center justify-center gap-2 w-[144px] py-3 text-white font-medium rounded-xl
           bg-gradient-to-r from-[#4A76B8] to-[#2D5EAB] hover:opacity-90 transition"> Login <span class="text-xl felx justify-center items-center">→</span>
        </button>
        <p *ngIf="params.user_type !== 'student'" class="text-[#2D5EAB] text-[16px] font-medium cursor-pointer hover:underline" (click)="openForgotPassword()"> Forgot Password </p>
      </div>
    </form>

    <form *ngIf="mode === 'forgot'" [formGroup]="forgotForm" class="space-y-5">

      <h2 class="text-2xl font-semibold text-gray-800">Forgot Password</h2>

      <!-- STEP 1 : EMAIL -->
      <ng-container *ngIf="forgotStep === 1">
        <div class="flex flex-col gap-[10px]" *ngIf=" user_type==='staff'">
          <p class=" font-normal text-[18px]">Email ID</p>
          <app-text-input [img]="'../../../assets/solar_user-broken.png'" [is_login]="true" [is_required]="true" class="w-full" placeholder="Enter Email ID" [label]="'Email'" formControlName="email"></app-text-input>
        </div>
        <div class="flex flex-col gap-[10px]" *ngIf="user_type === 'student'">
          <p class=" font-normal text-[18px]">User ID</p>
          <app-text-input [img]="'../../../assets/solar_user-broken.png'" [is_login]="true" [is_required]="true" class="w-full" placeholder="Enter User ID" [label]="'User Id'" formControlName="roll_number"></app-text-input>
        </div>
        <div class="flex flex-col items-center gap-4 w-full">
          <button type="button" (click)="sendOtp()" class="flex items-center justify-center gap-2 w-[144px] py-3 text-white font-medium rounded-xl
           bg-gradient-to-r from-[#4A76B8] to-[#2D5EAB] hover:opacity-90 transition"> Send OTP <span class="text-xl felx justify-center items-center">→</span>
          </button>
        </div>
      </ng-container>

      <!-- STEP 2 : OTP -->
      <ng-container *ngIf="forgotStep === 2">
        <div>
          <div class="flex justify-between">
            <label class="text-sm text-gray-600">Enter OTP</label>
            <p class="text-center text-sm text-gray-600 mt-3">
              OTP expires in
              <span class="text-red-600 font-semibold">{{ otpTime }}</span>
            </p>
          </div>
          <div class="flex flex-col gap-2">
            <div class="flex justify-between gap-2 mt-2">
              <input *ngFor="let box of otpBoxes; let i = index" type="text" maxlength="1" class="w-12 h-12 border rounded-lg text-center text-xl focus:outline-blue-500" (input)="onOtpInput($event, i)" (keydown)="onOtpKeyDown($event, i)" />
            </div>
            <p *ngIf="otpError" class="text-red-500 text-sm mt-2 text-center">
              {{ otpError }}
            </p>
          </div>
        </div>

        <!-- RESEND -->
        <p class="text-end text-sm mt-2">
          <button class="text-blue-600 font-medium disabled:text-gray-400" [disabled]="!canResendOtp" (click)="resendOtp()">
            Resend OTP
          </button>
        </p>

        <div class="flex flex-col items-center gap-4 w-full">
          <button type="button" (click)="verifyOtp()" class="flex items-center justify-center gap-2 w-[144px] py-3 text-white font-medium rounded-xl
           bg-gradient-to-r from-[#4A76B8] to-[#2D5EAB] hover:opacity-90 transition"> Verify OTP <span class="text-xl felx justify-center items-center">→</span>
          </button>
        </div>
      </ng-container>

      <!-- STEP 3 : RESET PASSWORD -->
      <ng-container *ngIf="forgotStep === 3">
        <div class="flex flex-col gap-3">
          <div class="flex flex-col gap-[10px]">
            <p class="font-normal text-[18px]">New Password</p>
            <app-text-input [img]="'../../../assets/password.png'" [is_login]="true" type="password" [mask]="true" [is_required]="true" class="w-full" [label]="'New Password'" formControlName="new_password"></app-text-input>
          </div>
          <div class="flex flex-col gap-[10px]">
            <p class="font-normal text-[18px]">Confirm Password</p>
            <app-text-input [img]="'../../../assets/password.png'" [is_login]="true" type="password" [mask]="true" [is_required]="true" class="w-full" [label]="'Confirm Password'" formControlName="confirm_password"></app-text-input>
          </div>
          <p *ngIf="forgotForm.get('new_password')?.invalid && forgotForm.get('new_password')?.touched" class="text-red-500 text-xs -mt-2">
            <ng-container *ngIf="forgotForm.get('new_password')?.hasError('required'); else pwdMinLen1">New Password is required</ng-container>
            <ng-template #pwdMinLen1><ng-container *ngIf="forgotForm.get('new_password')?.hasError('minlength'); else pwdPattern1">Minimum 8 characters required</ng-container></ng-template>
            <ng-template #pwdPattern1>Must include uppercase, lowercase, number and special character</ng-template>
          </p>
        </div>
        <p *ngIf="forgotForm.hasError('passwordMismatch') && forgotForm.get('confirm_password')?.touched" class="text-red-500 text-sm text-center">
          Passwords do not match
        </p>
        <button [disabled]="reset_form.value.new_password !== reset_form.value.confirm_password" type="button" class="w-full bg-blue-600 text-white py-3 rounded-lg" (click)="resetPassword()">
          Reset Password →
        </button>
      </ng-container>

      <p class="text-center text-sm text-gray-600 cursor-pointer" (click)="backToLogin()">
        ← Back to Login
      </p>

    </form>

  </div>

  <!-- AADHAAR VERIFICATION - Full Width -->
  <div *ngIf="mode === 'aadhaar'" class="relative w-full min-h-screen bg-[#ECEEF4] flex flex-col">

    <!-- Content -->
    <div class="flex-1 flex items-center justify-center px-8 py-10 bg-white">
      <div class="w-full max-w-[1100px] bg-[#EBF2FF] rounded-[28px] p-8 flex gap-6 items-stretch">

        <!-- LEFT: QR panel -->
        <div class="flex-1 flex flex-col gap-5 min-w-0">

          <!-- White QR card -->
          <div class="bg-transparent  flex items-center justify-center">
            <ng-container *ngIf="aadhaar_status === 'pending'">
              <img *ngIf="aadhaar_qr_image" [src]="'data:image/png;base64,' + aadhaar_qr_image" alt="Aadhaar QR Code" class="w-[468px] h-[468px] object-contain" />
              <!-- Placeholder when no QR yet -->
              <div *ngIf="!aadhaar_qr_image" class="w-[468px] h-[468px] bg-gray-50  rounded-sm flex items-center justify-center">
                <svg class="w-8 h-8 text-gray-300 animate-spin" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
                </svg>
              </div>
            </ng-container>
            <ng-container *ngIf="aadhaar_status === 'failed'">
              <div class="w-[468px] h-[468px] flex flex-col items-center justify-center gap-4 bg-red-50 rounded-xl">
                <svg class="w-14 h-14 text-red-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
                </svg>
                <p class="text-red-500 font-medium text-center text-sm">Verification failed.<br />Please try again.</p>
                <button type="button" (click)="retryAadhaar()" class="px-5 py-2 bg-[#3F41D1] text-white rounded-lg text-sm font-medium hover:opacity-90 transition">
                  Retry
                </button>
              </div>
            </ng-container>
          </div>

          <!-- Title + subtitle below QR (centered) -->
          <div class="flex flex-col items-center gap-[6px] text-center">
            <p class="font-bold text-[22px] leading-tight text-[#1A1A1A]">Scan to verify your aadhaar</p>
            <p class="text-[14px] text-[#6B7280] leading-snug">Scan this QR using the Aadhaar App to verify your aadhaar</p>
            <div *ngIf="aadhaar_status === 'pending'" class="flex items-center gap-2 text-[#3F41D1] text-[13px] mt-1 animate-pulse">
              <svg class="w-[14px] h-[14px] animate-spin flex-shrink-0" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
              </svg>
              Waiting for verification...
            </div>
          </div>

          <!-- Push download to bottom -->
          <div class="flex-1"></div>

          <!-- Download section — left-aligned -->
          <div class="flex flex-col gap-[10px]">
            <p class="text-[#3F41D1] font-semibold text-[15px]">Download the Aadhaar app on</p>
            <div class="flex gap-3 flex-wrap">
              <a href="https://play.google.com/store/apps/details?id=in.gov.uidai.mAadhaarPlus" target="_blank" class="flex items-center gap-[10px] bg-black text-white pl-3 pr-4 py-[10px] rounded-xl min-w-[148px]">
                <svg class="w-[22px] h-[22px] flex-shrink-0" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M3.18 23.76c.3.17.65.2.98.09l11.65-6.72-2.62-2.62-10.01 9.25zm-1.44-20.2A1.5 1.5 0 001.5 4.8v14.4c0 .47.22.9.6 1.16l.09.06 8.07-8.07v-.19L1.74 3.56zm14.44 9.2l-2.72-2.72-2.72 2.72 2.72 2.72 2.72-2.72zm2.28-7.17l-3.6 2.08 2.62 2.62 1.02-.59c.9-.52.9-1.62 0-2.11z" />
                </svg>
                <div class="flex flex-col leading-none gap-[2px]">
                  <span class="text-[9px] text-gray-400 uppercase tracking-wide">GET IT ON</span>
                  <span class="text-[13px] font-semibold">Google Play</span>
                </div>
              </a>
              <a href="https://apps.apple.com/in/app/maadhaar/id1435469222" target="_blank" class="flex items-center gap-[10px] bg-black text-white pl-3 pr-4 py-[10px] rounded-xl min-w-[148px]">
                <svg class="w-[22px] h-[22px] flex-shrink-0" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98l-.09.06c-.22.14-2.19 1.28-2.17 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.77M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
                </svg>
                <div class="flex flex-col leading-none gap-[2px]">
                  <span class="text-[9px] text-gray-400 uppercase tracking-wide">Download on the</span>
                  <span class="text-[13px] font-semibold">App Store</span>
                </div>
              </a>
            </div>
          </div>

        </div>

        <!-- RIGHT: Instructions panel -->
        <div class="w-[350px] flex-shrink-0 bg-white rounded-2xl shadow-[0_2px_12px_rgba(0,0,0,0.08)] p-6 flex flex-col">

          <!-- Step 1 row -->
          <div class="flex items-center gap-3 mb-5">
            <div class="w-9 h-9 rounded-full bg-[#3F41D1] flex items-center justify-center flex-shrink-0">
              <span class="text-white font-semibold text-[15px]">1</span>
            </div>
            <span class="text-[#3F41D1] font-bold text-[20px] leading-tight">Aadhaar verification</span>
          </div>

          <div class="flex gap-6">
            <div class="border-l border-gray-400 w-1 h-full ml-4"></div>

            <!-- Instructions block — indented to align with text after circle -->
            <div class=" flex flex-col">
              <p class="text-[#9CA3AF] text-[13px] font-medium mb-4">Instructions:</p>
              <div class="flex flex-col gap-[18px]">

                <div class="flex flex-col gap-[3px]">
                  <p class="text-[13px] font-semibold text-[#111827]">1. Face the camera directly</p>
                  <p class="text-[13px] text-[#6B7280] leading-[1.5]">Keep your face centred and look straight into the lens — avoid tilting or turning your head</p>
                </div>

                <div class="flex flex-col gap-[3px]">
                  <p class="text-[13px] font-semibold text-[#111827]">2. Use good lighting</p>
                  <p class="text-[13px] text-[#6B7280] leading-[1.5]">Sit facing a light source. Avoid backlighting or shadows across your face</p>
                </div>

                <div class="flex flex-col gap-[3px]">
                  <p class="text-[13px] font-semibold text-[#111827]">3. Remove obstructions</p>
                  <p class="text-[13px] text-[#6B7280] leading-[1.5]">Take off sunglasses, caps, or masks. Prescription glasses are allowed</p>
                </div>

                <div class="flex flex-col gap-[3px]">
                  <p class="text-[13px] font-semibold text-[#111827]">4. Stay still while capturing</p>
                  <p class="text-[13px] text-[#6B7280] leading-[1.5]">Hold steady for 2–3 seconds after pressing capture for a sharp, clear image</p>
                </div>

              </div>
            </div>
          </div>

          <!-- Step 2 row (inactive, bottom) -->
          <div class="flex items-center gap-3 pt-5">
            <div class="w-9 h-9 rounded-full border-[2px] border-[#D1D5DB] flex items-center justify-center flex-shrink-0">
              <span class="text-[#9CA3AF] font-semibold text-[15px]">2</span>
            </div>
            <span class="text-[#9CA3AF] text-[18px] font-medium">Face verification</span>
          </div>

        </div>
      </div>
    </div>
  </div>

  <!-- ═══════════════════════════════════════════════════════════
       FACE VERIFICATION  —  Figma 4443-32160
       ═══════════════════════════════════════════════════════════ -->
  <div *ngIf="mode === 'face'" class="min-h-screen w-full bg-[#ECEEF4] flex flex-col">

    <!-- HEADER -->
    <header class="h-16 flex-shrink-0 bg-white
                   px-4 sm:px-5 lg:px-8
                   flex items-center justify-between
                   border-b border-gray-100
                   shadow-[0_1px_4px_rgba(0,0,0,0.06)]">
      <img src="https://www.hubblehox.com/wp-content/uploads/2025/01/hubblehox-favicon.png?v=2" class="h-9 w-auto" alt="HubbleHox" />
      <div *ngIf="face_login_response?.data?.name" class="flex items-center gap-2">
        <div class="w-9 h-9 rounded-full bg-[#3F41D1] flex items-center justify-center flex-shrink-0">
          <span class="text-white text-[14px] font-semibold">{{ face_login_response?.data?.name?.charAt(0)?.toUpperCase() }}</span>
        </div>
        <span class="text-[14px] font-medium text-[#111827]">{{ face_login_response?.data?.name }}</span>
        <svg class="w-4 h-4 text-[#6B7280]" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
        </svg>
      </div>
    </header>

    <!-- MAIN -->
    <main class="flex-1 flex items-start lg:items-center justify-center
                 py-5 px-4 sm:py-6 sm:px-5 lg:py-8 lg:px-8">

      <!-- BLUE CARD -->
      <div class="w-full max-w-[1100px] bg-[#EBF2FF] items-stretch
                  flex flex-col gap-5 p-5 rounded-2xl
                  sm:flex-row sm:gap-4 sm:p-6 sm:rounded-[28px]
                  lg:flex-row lg:gap-6 lg:p-8 lg:rounded-[28px]">

        <!-- ══ LEFT PANEL: Camera ══ -->
        <div class="w-full sm:flex-1 min-w-0 flex flex-col items-center gap-5">

          <!-- Camera container — 4:3 aspect -->
          <div class="relative w-full max-w-[580px] rounded-2xl overflow-hidden bg-gray-700" style="aspect-ratio: 4/3;">
            <video #videoEl autoplay playsinline class="w-full h-full object-cover" [style.transform]="'scaleX(-1)'" [style.display]="face_image_base64 ? 'none' : 'block'">
            </video>
            <img *ngIf="face_image_base64" [src]="face_image_base64" class="w-full h-full object-cover" />

            <!-- Green corner brackets + oval overlay (live camera only) -->
            <ng-container *ngIf="!face_image_base64">
              <div class="absolute inset-0 pointer-events-none">
                <!-- Top-left bracket -->
                <div class="absolute top-5 left-5 w-9 h-9
                            border-t-[3px] border-l-[3px] border-[#22C55E] rounded-tl-lg"></div>
                <!-- Top-right bracket -->
                <div class="absolute top-5 right-5 w-9 h-9
                            border-t-[3px] border-r-[3px] border-[#22C55E] rounded-tr-lg"></div>
                <!-- Bottom-left bracket -->
                <div class="absolute bottom-5 left-5 w-9 h-9
                            border-b-[3px] border-l-[3px] border-[#22C55E] rounded-bl-lg"></div>
                <!-- Bottom-right bracket -->
                <div class="absolute bottom-5 right-5 w-9 h-9
                            border-b-[3px] border-r-[3px] border-[#22C55E] rounded-br-lg"></div>
                <!-- Green oval guide -->
                <div class="absolute inset-0 flex items-center justify-center">
                  <div class="w-[52%] h-[84%] rounded-full border-[3px] border-[#22C55E]"></div>
                </div>
              </div>
            </ng-container>
          </div>

          <!-- Hidden canvas for capture -->
          <canvas #canvasEl class="hidden"></canvas>

          <!-- Guide text (hide when approval pending) -->
          <div *ngIf="!face_approval_pending" class="text-center flex flex-col gap-[6px]">
            <p class="text-[18px] font-bold text-[#111827] leading-tight">
              Align your face within the oval frame
            </p>
            <p class="text-[14px] text-[#6B7280] leading-snug">
              Ensure good lighting and remove obstructions
            </p>
          </div>

          <!-- Approval pending guide text -->
          <div *ngIf="face_approval_pending" class="text-center flex flex-col gap-[6px]">
            <p class="text-[18px] font-bold text-[#008A2E] leading-tight">Prefect!!</p>
            <p class="text-[14px] text-[#6B7280] leading-snug">
              You can Send for approval to the next step or recapture your image
            </p>
          </div>

          <!-- Error -->
          <p *ngIf="face_error" class="text-red-500 text-[13px] text-center">{{ face_error | json }}</p>

          <!-- Buttons — normal state -->
          <div *ngIf="!face_approval_pending" class="flex items-center gap-4">
            <button *ngIf="!face_image_base64" [disabled]="this.face_error != ''" type="button" (click)="captureImage()" [ngClass]="{'opacity-70 cursor-not-allowed': this.face_error != ''}" class="flex items-center gap-3 px-10 py-[14px] bg-[#3F41D1] text-white rounded-full text-[16px] font-semibold transition">
              <svg class="w-5 h-5 flex-shrink-0" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 15.2A3.2 3.2 0 018.8 12 3.2 3.2 0 0112 8.8a3.2 3.2 0 013.2 3.2 3.2 3.2 0 01-3.2 3.2m7.9-8.4-1.8-.8A2 2 0 0016.2 5H7.8A2 2 0 006 5.8L3.8 6.8A2 2 0 002 8.6V18a2 2 0 002 2h16a2 2 0 002-2V8.6a2 2 0 00-2.1-1.8z" />
              </svg>
              Capture
            </button>

            <ng-container *ngIf="face_image_base64">
              <button type="button" (click)="retakeFace()" class="px-8 py-[14px] border-2 border-[#3F41D1] text-[#3F41D1]
                             rounded-full text-[15px] font-semibold hover:bg-[#EBF2FF] transition">
                Retake
              </button>
              <button type="button" (click)="submitFaceVerification()" [disabled]="face_loading" class="flex items-center gap-2 px-8 py-[14px] bg-[#3F41D1] text-white
                             rounded-full text-[15px] font-semibold hover:opacity-90 transition disabled:opacity-60">
                <svg *ngIf="face_loading" class="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
                </svg>
                {{ face_loading ? (face_is_resubmission ? 'Submitting...' : 'Verifying...') : (face_is_resubmission ? 'Re-Submit for Approval' : (is_first_login ? 'Register Face' : 'Verify')) }}
              </button>
            </ng-container>
          </div>

          <!-- Buttons — approval pending state -->
          <div *ngIf="face_approval_pending" class="flex items-center gap-4">
            <button type="button" (click)="retakeFromApprovalPending()" class="flex items-center gap-2 px-8 py-[14px] border-2 border-[#3F41D1] text-[#3F41D1]
                           rounded-full text-[15px] font-semibold hover:bg-[#EBF2FF] transition">
              <svg class="w-4 h-4 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
              </svg>
              Re-Capture
            </button>
            <button type="button" (click)="sendForApproval()" [disabled]="face_approval_loading" class="flex items-center gap-2 px-8 py-[14px] bg-[#3F41D1] text-white
                           rounded-full text-[15px] font-semibold hover:opacity-90 transition disabled:opacity-60">
              <svg *ngIf="face_approval_loading" class="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
              </svg>
              {{ face_approval_loading ? 'Submitting...' : 'Send For Approval' }}
            </button>
          </div>

        </div>
        <!-- ══ END LEFT PANEL ══ -->

        <!-- ══ RIGHT PANEL: Steps + Instructions ══ -->
        <aside class="w-full sm:w-[300px] lg:w-[352px] flex-shrink-0
                      bg-white rounded-2xl
                      p-5 lg:p-6
                      shadow-[0_2px_12px_rgba(0,0,0,0.08)]
                      flex flex-col">

          <!-- Step 1: Complete — green circle + green text -->
          <div class="flex items-center gap-3 mb-3">
            <div class="w-9 h-9 rounded-full bg-[#008A2E]
                        flex items-center justify-center flex-shrink-0">
              <svg class="w-[18px] h-[18px] text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <span class="text-[18px] font-semibold text-[#008A2E] leading-tight">
              Aadhaar verification
            </span>
          </div>

          <!-- Connector line -->
          <div class="w-px h-5 bg-[#D1D5DB] ml-[18px] mb-3"></div>

          <!-- Step 2: Active — blue circle + blue text -->
          <div class="flex items-center gap-3 mb-5">
            <div class="w-9 h-9 rounded-full bg-[#3F41D1]
                        flex items-center justify-center flex-shrink-0">
              <span class="text-[14px] font-semibold text-white">2</span>
            </div>
            <span class="text-[20px] font-bold text-[#3F41D1] leading-tight">
              Face verification
            </span>
          </div>

          <!-- Instructions indented to align with step text -->
          <div class="pl-[48px] flex flex-col flex-1">
            <p class="text-[13px] font-medium text-[#9CA3AF] mb-4">Instructions:</p>
            <div class="flex flex-col gap-[14px] lg:gap-[18px]">
              <div class="flex flex-col gap-[3px]">
                <p class="text-[13px] font-semibold text-[#111827]">1. Face the camera directly</p>
                <p class="text-[13px] text-[#6B7280] leading-[1.5]">Keep your face centred and look straight into the lens — avoid tilting or turning your head</p>
              </div>
              <div class="flex flex-col gap-[3px]">
                <p class="text-[13px] font-semibold text-[#111827]">2. Use good lighting</p>
                <p class="text-[13px] text-[#6B7280] leading-[1.5]">Sit facing a light source. Avoid backlighting or shadows across your face</p>
              </div>
              <div class="flex flex-col gap-[3px]">
                <p class="text-[13px] font-semibold text-[#111827]">3. Remove obstructions</p>
                <p class="text-[13px] text-[#6B7280] leading-[1.5]">Take off sunglasses, caps, or masks. Prescription glasses are allowed</p>
              </div>
              <div class="flex flex-col gap-[3px]">
                <p class="text-[13px] font-semibold text-[#111827]">4. Stay still while capturing</p>
                <p class="text-[13px] text-[#6B7280] leading-[1.5]">Hold steady for 2–3 seconds after pressing capture for a sharp, clear image</p>
              </div>
            </div>
          </div>

          <!-- Manual approval warning (shown on mismatch) -->
          <div *ngIf="face_approval_pending" class="mt-4 border border-[#FCD34D] bg-[#FFFBEB] rounded-xl p-4">
            <p class="text-[13px] font-semibold text-[#92400E] mb-1">Manual approval requested</p>
            <p class="text-[13px] text-[#92400E] leading-[1.5]">Automatic face detection couldn't verify you. An admin will review your photo against your Aadhaar record.</p>
          </div>

        </aside>
        <!-- ══ END RIGHT PANEL ══ -->

      </div>
    </main>
  </div>

</div>

<!-- Face ID Confirmation Modal (first login only) -->
<div *ngIf="show_face_confirm_modal" class="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
  <div class="bg-white rounded-2xl shadow-2xl px-8 py-8 w-full max-w-sm mx-4 text-center">
    <p class="text-[22px] font-bold text-[#111827] mb-2">Are you sure you want to proceed?</p>
    <p class="text-[14px] text-[#6B7280] mb-8">This action will save your face ID with us and it cannot be undone</p>
    <div class="flex gap-4">
      <button type="button" (click)="cancelFaceConfirm()" class="flex-1 py-[14px] rounded-full border border-[#D1D5DB] text-[#111827] text-[15px] font-semibold hover:bg-gray-50 transition">
        No
      </button>
      <button type="button" (click)="confirmFaceAndProceed()" class="flex-1 py-[14px] rounded-full bg-[#3F41D1] text-white text-[15px] font-semibold hover:opacity-90 transition">
        Yes, Proceed
      </button>
    </div>
  </div>
</div>

<app-modal #form_modal label="Reset Password">
  <form [formGroup]="reset_form">
    <div class="flex flex-col gap-4">
      <app-text-input [img]="'../../../assets/password.png'" [is_login]="true" type="password" [mask]="true" [is_required]="true" class="w-full" [label]="'New Password'" formControlName="new_password"></app-text-input>
      <p *ngIf="reset_form.get('new_password')?.invalid && reset_form.get('new_password')?.touched" class="text-red-500 text-xs -mt-2">
        <ng-container *ngIf="reset_form.get('new_password')?.hasError('required'); else pwdMinLen2">New Password is required</ng-container>
        <ng-template #pwdMinLen2><ng-container *ngIf="reset_form.get('new_password')?.hasError('minlength'); else pwdPattern2">Minimum 8 characters required</ng-container></ng-template>
        <ng-template #pwdPattern2>Must include uppercase, lowercase, number and special character</ng-template>
      </p>
      <app-text-input [img]="'../../../assets/password.png'" [is_login]="true" type="password" [mask]="true" [is_required]="true" class="w-full" [label]="'Confirm Password'" formControlName="confirm_password"></app-text-input>
    </div>
    <p *ngIf="reset_form.hasError('passwordMismatch') && reset_form.get('confirm_password')?.touched" class="text-red-500 text-sm text-center">
      Passwords do not match
    </p>
    <div class="flex justify-end items-center gap-2 mt-6">
      <app-button color="border-primary text-primary" label="Cancel" type="button" (click)="close_form_modal()"></app-button>
      <app-button [disabled]="reset_form.value.new_password !== reset_form.value.confirm_password" color="bg-secondary text-black" label="Add" type="button" (click)="reset()"></app-button>
    </div>
  </form>
</app-modal>